'use client';

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { BrowserLink } from '@/_kit/browser-link';
import { EColors } from '@/_types';
import { ArrowRightIcon } from '@/_kit/icons/arrow-right-icon';
import { useAnalytics } from '@/_hooks/use-analytics';
import { EAnalytics } from '@/_constants/analytics';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';
import { TLink } from '@/_components/support/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Link';

export const Link = ({ route, text, id, isResolveUrl }: TLink) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();

  const handleClick = useCallback(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_SUPPORT_T,
      params: {
        // eslint-disable-next-line camelcase
        link_name: id,
      },
    };

    sendEvent(config);
  }, [id, sendEvent]);

  return (
    <div className={cn(BLOCK_NAME)}>
      <BrowserLink
        color={EColors.BLACK}
        iconClassName={cn(`${BLOCK_NAME}__icon`)}
        isResolveUrl={isResolveUrl}
        onClick={handleClick}
        rel="noopener noreferrer"
        // eslint-disable-next-line @portals/custom-plugin/todo-checker
        // TODO: use use client inside icon component???
        rightIcon={ArrowRightIcon}
        routeName={route}
        target="_blank"
      >
        <Text size={ETextSize.SMALL} text={translations(text)} variant="body" />
      </BrowserLink>
    </div>
  );
};
